import React, { createContext, useState } from 'react';
export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [subscribedTopicString, setSubscribedTopicString] = useState("");
    const [publishedTopicString, setPublishedTopicString] = useState("");
    const [activeTab, setActivetab] = useState(localStorage.getItem("LastActiveTab") ? JSON.parse(localStorage.getItem("LastActiveTab"))  : "demo" );
    const [activeDataChip, setActiveDataChip] = useState(localStorage.getItem("LastActiveDataChip") ? JSON.parse(localStorage.getItem("LastActiveDataChip"))  : "car_maker" );
    const [columnData, setColumnData] = useState([]);



    return (
        <AppContext.Provider value={{
            subscribedTopicString,
            setSubscribedTopicString,
            publishedTopicString,
            setPublishedTopicString,
            activeTab,
            setActivetab,
            activeDataChip,
            setActiveDataChip,
            columnData,
            setColumnData,
        }}>
            {children}
        </AppContext.Provider>
    );
};
